import { render, staticRenderFns } from "./load.vue?vue&type=template&id=3ad3ab1e&scoped=true&"
import script from "./load.vue?vue&type=script&lang=js&"
export * from "./load.vue?vue&type=script&lang=js&"
import style0 from "./load.vue?vue&type=style&index=0&id=3ad3ab1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3ab1e",
  null
  
)

export default component.exports